import { Step } from '../../types/tour';

export const sidebar: Step[] = [
  { id: 1, label: 'Introduction', completed: false },
  { id: 2, label: 'Setup Connection', completed: false },
  { id: 3, label: 'Create Channel', completed: false },
  { id: 4, label: 'Send Message', completed: false },
  { id: 5, label: 'Reactions', completed: false },
  { id: 6, label: 'Threads', completed: false },
  { id: 7, label: 'State & Listening', completed: false },
  { id: 8, label: 'Conclusion', completed: false },
];
